import { useEffect } from 'react';

import { useStepState } from 'src/app/pages/startAPetition/pageContext';

export function SkipStep(): null {
	const { data, actions } = useStepState();

	useEffect(() => {
		if (data.metadata.direction === 'forward') actions.skipStep();
		if (data.metadata.direction === 'back') actions.gotoPreviousStep();
	}, [actions, data.metadata.direction]);

	return null;
}
